<template>
  <a-popover trigger="hover">
    <template slot="content">
      <p>建议图片大小为：宽：400，高：{{ height }}，效果最佳</p>
    </template>
    <a-icon type="exclamation-circle" style="color:#f37b1d" />
  </a-popover>
</template>
<script>
export default {
  props: {
    height: {
      type: String,
      default() {
        return '300'
      }
    }
  }
}
</script>
